import MutateQuiz from "./MutateQuiz";

export default MutateQuiz